import { SvgIcon } from '@material-ui/core';

export const WarningIcon = () => (
  <SvgIcon viewBox="0 0 24 24">
    <path
      d="M1 21h22L12 2 1 21z"
      fill="none"
      stroke="#ff543e"
      strokeWidth="1.5"
    />
    <rect x="11" y="10" width="2" height="5" fill="#ff543e" />
    <rect x="11" y="16" width="2" height="2" fill="#ff543e" />
  </SvgIcon>
);
